export default {
  items: [
    {
      name: 'Início',
      url: '/',
      icon: 'icon-speedometer',
      rule: 'isUser',
    },
    {
      title: true,
      class: '',
      name: 'Horas',
      rule: 'isUser',
    },
    {
      name: 'Lançamentos',
      url: '/horas/apontamento',
      icon: 'icon-clock',
      rule: 'isUser',
    },
    {
      name: 'Histórico',
      url: '/horas/historico',
      icon: 'icon-calendar',
      rule: 'isUser',
    },
    {
      name: 'Orçamento',
      url: '/competencia/orcamento',
      icon: 'fa fa-dollar',
      rule: 'isUser',
    },
    {
      name: 'Alocação',
      url: '/horas/alocacao',
      icon: 'fa fa-calendar',
      rule: 'isUser',
    },
    {
      title: true,
      class: '',
      name: 'Configuração',
      rule: 'isAdmin',
    },
    {
      name: 'Sincronizar Projetos',
      url: '/projetos/sincronizar',
      icon: 'icon-share',
      rule: 'isAdmin',
    },
    {
      title: true,
      class: '',
      name: 'Competências',
      rule: 'isUser',
    },
    {
      name: 'Sincronizar',
      url: '/competencia/parametrizar',
      icon: 'icon-calendar',
      rule: 'isAdmin',
    },
    {
      name: 'Bloquear',
      url: '/competencia/bloquear',
      icon: 'icon-ban',
      rule: 'isAdmin',
    },
    {
      name: 'Fechamento',
      url: '/competencia/fechamento',
      icon: 'icon-briefcase',
      rule: 'isAdmin',
    },
    {
      name: 'Faturamento',
      url: '/competencia/faturamento',
      icon: 'fa fa-money',
      rule: 'isAdmin',
    },
    {
      name: 'Faturamento Funcio...',
      url: '/competencia/faturamento-funcional',
      icon: 'fa fa-money',
      rule: 'isAdmin',
    },
    {
      name: 'Faturamento AMS',
      url: '/competencia/faturamento-ams',
      icon: 'fa fa-money',
      rule: 'isAdmin',
    },
    {
      name: 'Melhorias por Devs',
      url: '/competencia/faturamento-desenvolvedores',
      icon: 'fa fa-money',
      rule: 'isAdmin',
    },
    {
      name: 'Horas Fábrica Devs',
      url: '/competencia/horas-fabrica-devs',
      icon: 'fa fa-money',
      rule: 'isAdmin',
    },
    {
      name: 'Orçamentos',
      url: '/competencia/orcamento-analistas',
      icon: 'fa fa-dollar',
      rule: 'isUser',
    },
    {
      title: true,
      class: '',
      name: 'Gestão de Demandas',
      rule: 'isUser',
    },
    {
      name: 'Plano de Atividades',
      url: '/gestao/prioridades',
      icon: 'icon-clock',
      rule: 'isUser',
    },
    {
      title: true,
      class: '',
      name: 'Gestor',
      rule: 'isGestor',
    },
    {
      name: 'Usuários',
      url: '/gestor/usuarios',
      icon: 'icon-user',
      rule: 'isGestor',
    },
    {
      name: 'Liberação de Horas',
      url: '/gestor/liberacao',
      icon: 'icon-hourglass',
      rule: 'isGestor',
    },
    {
      name: 'Projetos',
      url: '/gestor/projetos',
      icon: 'icon-notebook',
      rule: 'isGestor',
    },
  ]
}
